module.exports = __webpack_public_path__ + "static/media/confidentiality.fe4789d1.svg";